import React, { memo } from 'react';
import { Button, Text, Tooltip } from '@beef/ui-kit';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Icon } from "../../../../../../../Icon";
import styles from "./styles.pcss";
var cx = classnames.bind(styles);
export var ActionButton = /*#__PURE__*/memo(function (_ref) {
  var buttonText = _ref.buttonText,
    agreementText = _ref.agreementText,
    tooltipText = _ref.tooltipText,
    isLoading = _ref.isLoading,
    formId = _ref.formId,
    isIcon = _ref.isIcon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('text'),
    "data-t-id": "RenderRequestForm-ActionButton"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size6-r"
  }, agreementText), ' ', isIcon && /*#__PURE__*/React.createElement(Tooltip, {
    maxWidth: "280",
    message: tooltipText,
    position: "top",
    variant: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "FTTBInfo",
    "data-t-id": "RenderRequestForm-ActionButton"
  }))), /*#__PURE__*/React.createElement(Button, {
    extraAttributes: {
      form: formId
    },
    isLoading: isLoading,
    type: "submit"
  }, buttonText));
});
ActionButton.propTypes = {
  buttonText: PropTypes.string,
  agreementText: PropTypes.string,
  tooltipText: PropTypes.string,
  isLoading: PropTypes.bool,
  formId: PropTypes.string,
  isIcon: PropTypes.bool
};